(function (root, factory) {
  "use strict";
  if (typeof module === "object" && module.exports) module.exports = factory();
  else root.NutricellsInstructionPlan = factory();
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  const PARAMETER = "nc_sample";
  const BASE_URL = "https://nutricells.de/pages/testanleitung";

  // The link transports the card's displayed amounts, not customer data or a registration code.
  function decode(value) {
    const match = /^1\.([12])\.([1-9]\d?(?:-[1-9]\d?)?)$/.exec(value || "");
    if (!match) return null;
    const decimals = Number(match[1]);
    const amounts = match[2].split("-").map(Number);
    if (amounts.some(amount => amount > 80 || (decimals === 1 && amount % 10 !== 0))) return null;
    if (amounts.length === 2 && amounts[0] !== 80) return null;
    return { decimals, amounts, total: amounts.reduce((sum, amount) => sum + amount, 0) };
  }

  function encode(plan) {
    if (!plan) return null;
    const volumes = plan.displayVolumes || plan.volumes;
    if (!Array.isArray(volumes) || ![1, 2].includes(plan.decimals)) {
      throw new Error("Invalid sample plan for instruction link.");
    }
    const amounts = volumes.map(volume => Math.round(Number(volume.toFixed(plan.decimals)) * 100));
    const value = `1.${plan.decimals}.${amounts.join("-")}`;
    if (!decode(value)) throw new Error("Unsupported sample amounts for instruction link.");
    return value;
  }

  function fromSearch(search) {
    const params = new URLSearchParams(search);
    return params.getAll(PARAMETER).length === 1 ? decode(params.get(PARAMETER)) : null;
  }

  function buildUrl(plan) {
    const value = encode(plan);
    return value ? `${BASE_URL}?${PARAMETER}=${value}` : BASE_URL;
  }

  function formatAmount(amount, decimals) {
    return `${(amount / 100).toFixed(decimals).replace(".", ",")} ml`;
  }

  return { PARAMETER, BASE_URL, decode, encode, fromSearch, buildUrl, formatAmount };
});
